module.exports = __webpack_public_path__ + "static/media/iconPencilWhite.1d077396.svg";